export const MARKET_CATEGORIES = [
  'B2B',
  'B2C',
  'E-Commerce',
  'Enterprise',
  'ISP',
  'Marketplace',
  'Mobile',
  'SAAS',
]


// WEBPACK FOOTER //
// ./src/scripts/components/settings/Rules/constants/market_categories.js